"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.object.keys");
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _utils = require("@/utils");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    disabledType: {
      type: Boolean,
      default: false
    },
    isSelectVessel: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      checkPol: true,
      listQuery: {
        // pol:"CNSHA",
        //   pod:"VNSGN",
        //   etd:"2024-04-13",
        etdTo: "",
        pol: "",
        pod: "",
        etd: "",
        currentPage: 1,
        pageSize: 10,
        vesselCode: "",
        voyageNo: "",
        voyageLeg: "",
        eta: "",
        etaTo: "",
        serviceLineCode: "",
        isTs: "0",
        pot: "",
        por: "",
        time: ''
        // bookingFlag: 1,
      },
      filterForm: {
        keyword: '',
        portOfDeparture: '',
        radio: '1',
        selectTime: '2',
        serviceLineCode: ''
      },
      options: [{
        value: '1',
        labelZh: '及后一周内',
        labelEh: '+1 Week'
      }, {
        value: '2',
        labelZh: '及后两周内',
        labelEh: '+2 Weeks'
      }, {
        value: '3',
        labelZh: '及后三周内',
        labelEh: '+3 Weeks'
      }, {
        value: '4',
        labelZh: '及后四周内',
        labelEh: '+4 Weeks'
      }],
      rules: {
        pol: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }],
        pod: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }],
        time: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'blur'
        }],
        por: [{
          required: true,
          message: this.$t('filter.pleaseEnterKeyWord'),
          trigger: 'change'
        }]
      },
      total: 0,
      tableData: [],
      loading: null,
      isShowSlotControl: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {
    this.handleGetTime();
  },
  methods: {
    selectableCallback: function selectableCallback(row, index) {
      return !(row.status === '1' || !this.checkPol);
    },
    parseTime: _utils.parseTime,
    handleGetTime: function handleGetTime() {
      if (this.filterForm.radio === '1') {
        this.listQuery.time = (0, _utils.parseTime)(new Date(), '{y}-{m}-{d}');
      } else {
        var oneDay = 24 * 60 * 60 * 1000;
        this.listQuery.time = new Date().getTime() + 7 * oneDay;
      }
    },
    showMessage: function showMessage(data) {
      var str = '';
      // const data = [{a:1,b:2},{a:2,b:3}]
      // 页面展示
      // 1 2
      // 2 3

      data.forEach(function (item, index) {
        str += "".concat(item.vesselCode, " ").concat(item.vesselName, " ").concat(item.voyageNo, " ").concat(item.voyageLeg, " \n ");
      });
      return str;
    },
    opened: function opened() {
      // this.handleSearch()
      console.log('opened');
      this.listQuery.pol = this.$parent.form.por ? this.$parent.form.por : '';
      this.listQuery.pod = this.$parent.form.del ? this.$parent.form.del : '';
    },
    handleClose: function handleClose() {
      console.log('handleClose');
      this.$parent.sailScheduleDialogVisible = false;
      this.$parent.sailScheduleDialogVisibleTemplate = false;
      this.closed();
    },
    changeSelect: function changeSelect(val) {
      this.caculateTime(this.listQuery.time);
    },
    handleReset: function handleReset() {
      for (var key in this.listQuery) {
        this.listQuery[key] = '';
      }
      this.listQuery.currentPage = 1;
      this.listQuery.pageSize = 10;
      this.listQuery.isTs = '0';
      this.listQuery.time = '';
      this.filterForm.selectTime = '2';
      this.filterForm.serviceLineCode = '';
      this.filterForm.vesselCode = '';
      this.filterForm.radio = '1';
      this.handleGetTime();
    },
    handleSelectionChange: function handleSelectionChange(selections, row) {
      if (selections.length > 1) {
        var del_row = selections.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
        this.multipleSelection = selections;
      } else {
        this.multipleSelection = selections;
      }
      var data = this.multipleSelection[0];
      if (data.slotControlStatus == '0' || data.polHidden !== 'CNSHK' || data.status === '1') {
        this.isShowSlotControl = true;
      } else {
        this.isShowSlotControl = false;
      }
    },
    // 判断有没有通告
    handleCheck: function () {
      var _handleCheck = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(row, type) {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(type === 2)) {
                _context.next = 4;
                break;
              }
              this.checkPol = true;
              this.checkDtaParams = true;
              return _context.abrupt("return");
            case 4:
              data = {
                pol: row.polHidden,
                singleContainerFlag: type
              };
              _context.next = 7;
              return this.$store.dispatch('isSaveTip/checkPol', row.polHidden);
            case 7:
              this.checkPol = _context.sent;
              if (this.checkPol) {
                _context.next = 12;
                break;
              }
              this.language === 'en' ? this.$message.error("This account does not have".concat(row.polHidden, "booking rights")) : this.$message.error("\u8BE5\u8D26\u53F7\u6CA1\u6709".concat(row.polHidden, "\u7684\u8BA2\u8231\u6743\u9650"));
              _context.next = 15;
              break;
            case 12:
              _context.next = 14;
              return this.$store.dispatch('isSaveTip/checkQuery', data);
            case 14:
              this.checkDtaParams = _context.sent;
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleCheck(_x, _x2) {
        return _handleCheck.apply(this, arguments);
      }
      return handleCheck;
    }(),
    handleCheckSubmit: function handleCheckSubmit() {
      this.$emit('selectionChange', this.multipleSelection[0]);
      this.$refs.checkNotice.checkVisible = false;
    },
    handleSubimt: function () {
      var _handleSubimt = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(data) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.handleCheck(this.multipleSelection[0], data);
            case 2:
              if (this.checkPol) {
                _context2.next = 4;
                break;
              }
              return _context2.abrupt("return");
            case 4:
              if (data < 2) {
                this.multipleSelection[0].singleContainerFlag = data;
              }
              if (this.checkDtaParams && Object.keys(this.checkDtaParams).length) {
                this.$parent.sailScheduleDialogVisible = false;
                this.$refs.checkNotice.checkVisible = true;
              } else {
                this.$emit('selectionChange', this.multipleSelection[0]);
              }
              console.log(this.multipleSelection[0], '9999999');
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleSubimt(_x3) {
        return _handleSubimt.apply(this, arguments);
      }
      return handleSubimt;
    }(),
    getValue: function getValue(val) {
      this.handleGetTime();
      this.lastTime();
    },
    changeTime: function changeTime(val) {
      console.log(val, '时间的惦');
      this.caculateTime(val);
    },
    caculateTime: function caculateTime(val) {
      if (val) {
        var mapObject = {
          '1': 7,
          '2': 14,
          '3': 21,
          '4': 28
        };
        var day = mapObject[this.filterForm.selectTime];
        console.log(val, '时间的惦222', this.filterForm.selectTime);
        var date = new Date(val);
        console.log(date, '时间的惦111');
        var timestamp = date.getTime();
        var oneDay = 24 * 60 * 60 * 1000;
        var newTimestamp = timestamp + day * oneDay;
        this.newDate = new Date(newTimestamp);
        console.log(this.newDate, val, '两周后的时间', day);
        this.lastTime();
      } else {
        this.listQuery.eta = '';
        this.listQuery.etaTo = '';
        this.listQuery.etd = '';
        this.listQuery.etdTo = '';
      }
    },
    lastTime: function lastTime() {
      if (this.filterForm.radio === '1') {
        this.listQuery.etd = (0, _utils.parseTime)(this.listQuery.time, '{y}-{m}-{d}');
        this.listQuery.etdTo = (0, _utils.parseTime)(this.newDate, '{y}-{m}-{d}');
        this.listQuery.eta = '';
        this.listQuery.etaTo = '';
      } else {
        this.listQuery.eta = (0, _utils.parseTime)(this.listQuery.time, '{y}-{m}-{d}');
        this.listQuery.etaTo = (0, _utils.parseTime)(this.newDate, '{y}-{m}-{d}');
        this.listQuery.etd = '';
        this.listQuery.etdTo = '';
      }
      console.log(this.listQuery.etd, this.listQuery.etdTo);
    },
    handleClear: function handleClear() {
      this.filterForm = {
        vesselCode: '',
        serviceLineCode: '',
        vesselNameCn: '',
        voyageNo: '',
        voyageLeg: '',
        currentPage: 1,
        pageSize: 10
      };
    },
    closed: function closed() {
      // this.handleClear()
    },
    handleSearch: function handleSearch() {
      var _this = this;
      this.$refs['listQuery'].validate(function (valid) {
        if (valid) {
          _this.caculateTime(_this.listQuery.time);
          var data = Object.assign({}, _this.listQuery);
          delete data.time;
          data.vesselCode = _this.filterForm.vesselCode;
          data.serviceLineCode = _this.filterForm.serviceLineCode;
          _this.loading = (0, _utils.load)();
          (0, _booking.queryVoyagePlanPage)(data).then(function (res) {
            if (res.success) {
              _this.tableData = res.data && res.data.records;
              _this.total = res.data && res.data.totalRecord;
            }
          }).finally(function () {
            _this.loading.close();
          });
        } else {
          return false;
        }
      });
    }
  }
};